import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SecondSidebar } from '@/app/NewNavigation/NewNavigationShell';
import { ProjectSidebar } from '@/app/NewNavigation/ProjectSidebar';
import type { PageStaticData } from '@/shared/routing';

// A project's pages beside its sidebar, which stays mounted across them. Today's tree has no such layout: the project
// navbar sits on each page.
export const Route = createFileRoute('/_authenticated/next/projects/$projectId')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const projectId = Route.useParams({ select: (params) => params.projectId });
    return (
        <>
            <SecondSidebar>
                <ProjectSidebar projectId={projectId} />
            </SecondSidebar>
            <Outlet />
        </>
    );
}
